import React from "react";
import { Container, Col, Row } from "reactstrap";
import { Facebook, Reddit, LinkedIn } from '@material-ui/icons';

const Footer = () => {
  return (
    <div className="footer-container">
      <Container className="footer-section">
        <Row className="footer-row">
        <Col lg={6} sm={12}>
          <Row>
            <Col lg={4}><p className="p-label">Services</p></Col>
            <Col lg={4}><p className="p-label">Company</p></Col>
            <Col lg={4}><p className="p-label">Support</p></Col>
          </Row>

          <Row>
            <Col lg={4}><p className="p-word">Pricing</p></Col>
            <Col lg={4}>
              <p className="p-word">About</p>
              <p className="p-word">Investors</p>
            </Col>
            <Col lg={4}><p className="p-word">Contact</p></Col>
          </Row>
        </Col>
        <Col lg={6} sm={12}>
          <Row>
            <Col lg={12}>
              <img className="img-logo-smile" src={require('../_assets/image/logo.png')} />
            </Col>
          </Row>
          <Row className="icn-row" lg={12}>
            <Facebook color={"primary"} fontSize="large" />
            <Reddit color={"secondary"} className="icn" fontSize="large" />
            <LinkedIn color={"primary"} className="icn" fontSize="large" />
          </Row>
          <Row className="container-copy">
            <p className="copyright">© COPYRIGHT 2015. ALL RIGHTS RESERVED.</p>
          </Row>
        </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;